module.exports = __webpack_public_path__ + "static/media/az.4436e304.svg";